import { getTestIds } from 'seagull/utils/TestIds';
export const addContactModalTextsPath = 'components.addContactModal';
export const CONTACT_FIELD_NAME = 'contact';
export const CONTACT_FORM_TEST_ID = 'add-contact-form';
export const ADD_CONTACT_FORM_DEFAULTS = {
    [CONTACT_FIELD_NAME]: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        qbo: null,
        xero: null
    }
};
export const GetAddContactModalTID = (parentTestId)=>getTestIds(parentTestId);
